import React from 'react'
import { ColumbiaTimesheetProvider } from './context/ColumbiaTimesheetProvider'
import { ColumbiaTimesheetMain } from './components/ColumbiaTimesheetMain'

export const ColumbiaTimesheet = () => (
  <ColumbiaTimesheetProvider>
    <ColumbiaTimesheetMain />
  </ColumbiaTimesheetProvider>
)
